// extracted by mini-css-extract-plugin
export var closeButton = "_t-0";